<i18n
  src="@/locales/views/agro_exporter/production/query_container_export/show_process.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<template>
  <div class="mt-6">
    <h1 class="page-title">
      <i class="fa-solid fa-ship"></i><span class="space-icon"></span>
      {{ $t("labels.exportations_title") }}
    </h1>

    <div class="flex flex-row justify-end">
      <div class="panel-plain-label">
        <badge-default
          :label="
            exportations.length + ' ' + $t('labels.total_number_exportations')
          "
        />
        <span class="space-actions" />
        <exportation-status
          :status_id="0"
          :prepend_label="' ' + numExportationsStatus0"
        />
        <span class="space-actions" />
        <exportation-status
          :status_id="1"
          :prepend_label="' ' + numExportationsStatus1"
        />
        <span class="space-actions" />
        <exportation-status
          :status_id="2"
          :prepend_label="' ' + numExportationsStatus2"
        />
      </div>
      <div class="grow"></div>

      <button
        type="button"
        @click.prevent="downloadExportationsContainersRepXlsx"
        class="btn-white"
      >
        <i
          :class="[
            'fa-solid',
            downloading_exportations_containers
              ? 'fa-sync fa-spin'
              : 'fa-file-excel'
          ]"
        ></i
        ><span class="space-icon"></span
        >{{ $t("labels.general_report_button") }}
      </button>
    </div>

    <div class="mt-8 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.week") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.booking_code") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.exportation_type") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.status") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.departured_at") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.container") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.destination_export") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.customer") }}
                  </th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="exportation in exportations"
                  :key="exportation.id"
                >
                  <td class="table-cell">
                    {{ exportation.week }}
                  </td>
                  <td
                    class="table-cell-main link"
                    @click.prevent="goToShowExportation(exportation.id)"
                  >
                    {{ exportation.booking_code }}
                  </td>
                  <td class="table-cell">
                    <exportation-type
                      :exportation_type_id="exportation.exportation_type_id"
                      :only_icon="true"
                    />
                  </td>
                  <td class="table-cell">
                    <exportation-status :status_id="exportation.status_id" />
                  </td>
                  <td class="table-cell">
                    {{ dateFormatterDayMonthName(exportation.departured_at) }}
                  </td>
                  <td class="table-cell">
                    <div
                      class="link"
                      v-for="container in exportation.containers"
                      :key="container.id"
                      @click.prevent="goToShowContainer(container.id)"
                    >
                      {{ container.container_code }}
                    </div>
                  </td>

                  <td class="table-cell">
                    {{ exportation.destination_export.name }}
                  </td>
                  <td class="table-cell">
                    <div
                      v-for="container in exportation.containers"
                      :key="container.id"
                    >
                      {{ container.customer.name }}
                    </div>
                  </td>
                  <td class="table-cell-action">
                    <exportation-details
                      :exportation="exportation"
                      icon="fa-solid fa-eye"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExportationStatus from "@/components/views/agro_exporter/production/shared/exportation/ExportationStatus.vue";
import ExportationType from "@/components/views/agro_exporter/production/shared/exportation/ExportationType.vue";
import ExportationDetails from "@/components/views/agro_exporter/production/shared/exportation/ExportationDetails.vue";
import Requester from "@/views/agro_exporter/requesters/production/query_container_export/show_process.js";
import ShowProcessTabsMixin from "@/components/views/agro_exporter/production/query_container_export/show_process/show_process_tabs_mixin.js";

export default {
  name: "ShowProcessExportations",
  components: {
    ExportationStatus,
    ExportationType,
    ExportationDetails
  },
  mixins: [ShowProcessTabsMixin],
  props: {
    exportations: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      downloading_exportations_containers: false
    };
  },
  computed: {
    numExportationsStatus0: function () {
      let n = 0;
      this.exportations.forEach(exportation => {
        if (exportation.status_id == 0) {
          n += 1;
        }
      });
      return n;
    },
    numExportationsStatus1: function () {
      let n = 0;
      this.exportations.forEach(exportation => {
        if (exportation.status_id == 1) {
          n += 1;
        }
      });
      return n;
    },
    numExportationsStatus2: function () {
      let n = 0;
      this.exportations.forEach(exportation => {
        if (exportation.status_id == 2) {
          n += 1;
        }
      });
      return n;
    }
  },
  methods: {
    downloadExportationsContainersRepXlsx: async function () {
      this.downloading_exportations_containers = true;
      try {
        let response = await Requester.downloadExportationsContainersRepXlsx(
          this.agro_exporter_process_id
        );

        const file = response.data;
        var fileURL = window.URL.createObjectURL(new Blob([file]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", "reporte_general.xlsx");
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        error;
      }
      this.downloading_exportations_containers = false;
    },
    goToShowExportation: function (exportation_id) {
      this.$router.push({
        name: this.routeName("show_exportation"),
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          exportation_id: exportation_id
        }
      });
    },
    goToShowContainer: function (container_id) {
      console.log(this.agro_exporter_process_id);
      this.$router.push({
        name: this.routeName("show_container"),
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: container_id
        }
      });
    }
  }
};
</script>
